import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApiRequest } from "../../services/getApiRequest";
import { END_POINTS } from "../../Helper/Constant";

export const fetchOneVsOneGameTypes = createAsyncThunk(
    "game/fetchOneVsOneGameTypes",
    async (_, { rejectWithValue }) => {
        try {
            const response = await getApiRequest(END_POINTS.GET_ALL_GAME_TYPES);
            if (response?.success) {
                return response.allGameTypes || [];
            }
            return rejectWithValue(
                response?.message || "Failed to fetch game types"
            );
        } catch (error) {
            return rejectWithValue(
                error?.response?.data?.message ||
                error?.error?.message ||
                error?.message ||
                "Failed to fetch game types"
            );
        }
    }
);

const initialState = {
    selectedGames: [],
    oneVsOneGameTypes: [],
    oneVsOneGameTypesLoading: false,
    oneVsOneGameTypesError: null,
};

const gameSlice = createSlice({
    name: "game",
    initialState,
    reducers: {
        setSelectedGames: (state, action) => {
            state.selectedGames = action.payload;
        },
        addGame: (state, action) => {
            const exists = state.selectedGames.find(
                (g) => g._id === action.payload._id
            );
            if (!exists) {
                state.selectedGames.push(action.payload);
            }
        },
        removeGame: (state, action) => {
            state.selectedGames = state.selectedGames.filter(
                (g) => g._id !== action.payload._id
            );
        },
        clearGames: (state) => {
            state.selectedGames = [];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchOneVsOneGameTypes.pending, (state) => {
                state.oneVsOneGameTypesLoading = true;
                state.oneVsOneGameTypesError = null;
            })
            .addCase(fetchOneVsOneGameTypes.fulfilled, (state, action) => {
                state.oneVsOneGameTypesLoading = false;
                state.oneVsOneGameTypes = action.payload;
            })
            .addCase(fetchOneVsOneGameTypes.rejected, (state, action) => {
                state.oneVsOneGameTypesLoading = false;
                state.oneVsOneGameTypesError = action.payload;
            });
    },
});

export const { setSelectedGames, addGame, removeGame, clearGames } =
    gameSlice.actions;

export const selectSelectedGames = (state) =>
    state.game?.selectedGames || [];
export const selectPrimarySelectedGame = (state) =>
    selectSelectedGames(state)[0] || null;

export const selectOneVsOneGameTypes = (state) =>
    state.game?.oneVsOneGameTypes || [];
export const selectOneVsOneGameTypesLoading = (state) =>
    state.game?.oneVsOneGameTypesLoading || false;
export const selectOneVsOneGameTypesError = (state) =>
    state.game?.oneVsOneGameTypesError || null;

export default gameSlice.reducer;
